<template>
  <div class="panel panel-default panel-dashboard">
    <div class="panel-body">
      <canvas width="800" height="250"/>

      <TheValueChartBreakdownModal :user="user" :breakdown="breakdown" :selected-breakdown="selectedBreakdown"/>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js'
import http from '@/http'
import moment from 'moment'
import TheValueChartBreakdownModal from './TheValueChartBreakdownModal'

export default {
  components: {TheValueChartBreakdownModal},

  props: {
    user: {
      required: true,
      type: Object
    },

    from: {
      required: true,
      type: String
    },

    to: {
      required: true,
      type: String
    },

    breakdown: {
      required: true,
      type: String
    }
  },

  data() {
    return {
      data: null,
      portals: null,
      selectedBreakdown: null,

      chart: null
    }
  },

  mounted() {
    this.load().then(this.draw)
  },

  watch: {
    from() {
      this.load().then(this.draw)
    },

    to() {
      this.load().then(this.draw)
    },

    breakdown() {
      this.load().then(this.draw)
    }
  },

  computed: {
    dataPromise() {
      return http.post('/api/v1/reports/new-analytics', {
        metrics: [
          {name: 'first_partnership_period_value'}
        ],
        dimensions: [
          {name: this.breakdown === 'months' ? 'sold_month' : 'sold_week'},
          {name: 'portal_id'},
          {name: 'portal_name'}
        ],
        filters: [
          {dimension: 'sold_at', operator: '>=', value: this.from},
          {dimension: 'sold_at', operator: '<=', value: this.to},
          {dimension: 'user_id', operator: '=', value: this.user.id}
        ]
      })
    },

    breakdowns() {
      let current = moment(this.from)

      let breakdowns = []

      while (current <= moment(this.to)) {
        breakdowns.push(
            current
                .startOf(this.breakdown === 'months' ? 'month' : 'isoWeek')
                .format(this.breakdown === 'months' ? 'MM/YYYY' : 'WW/YYYY')
        )

        current.add(1, this.breakdown === 'months' ? 'month' : 'week')
      }

      return breakdowns
    },

    datasets() {
      return this.portals
          .map(portal => this.getDataset(portal))
          .filter(dataset => dataset.data.reduce((sum, value) => sum + value, 0) > 0)
    }
  },

  methods: {
    load() {
      return Promise.all([
        this.dataPromise,
        http.get('/api/v2/portals')
      ]).then(responses => {
        this.data = responses[0].data.data

        this.portals = responses[1].data.data
      })
    },

    getDataset(portal) {
      return {
        label: portal.attributes.name,
        data: this.breakdowns.map(breakdown => {
          return this.data
              .filter(row => {
                if (this.breakdown === 'months') {
                  return row.sold_month === breakdown && row.portal_id === portal.id.toString()
                }

                return row.sold_week === breakdown && row.portal_id === portal.id.toString()
              })
              .reduce((sum, row) => sum + row.first_partnership_period_value, 0)
        }),
        backgroundColor: portal.attributes.color,
        borderColor: portal.attributes.color,
        fill: false
      }
    },

    draw() {
      if (this.chart) {
        this.chart.destroy()
      }

      this.chart = new Chart(this.$el.querySelector('canvas').getContext('2d'), {
        type: 'bar',

        data: {
          labels: this.breakdowns,
          datasets: this.datasets
        },

        options: {
          scales: {
            xAxes: [{
              stacked: true
            }],
            yAxes: [{
              stacked: true,
              ticks: {
                callback: label => this.$options.filters.price(label),
                beginAtZero: true
              }
            }]
          },

          legend: {
            position: 'bottom'
          },

          plugins: {
            datalabels: {
              display: false
            }
          },

          tooltips: {
            callbacks: {
              label: (t, d) => d.datasets[t.datasetIndex].label + ': ' + this.$options.filters.price(d.datasets[t.datasetIndex].data[t.index])
            }
          },

          onClick: (event, elements) => {
            if (elements.length) {
              this.selectedBreakdown = this.breakdowns[elements[0]['_index']]

              this.$nextTick(() => $('#value-chart-breakdown-modal').modal('show'))
            }
          }
        }
      })
    }
  }
}
</script>
